var map = {
	"./cashier/external_links_cashier_handler.js": 6046,
	"./common/external_links_common_link_handler.js": 9035,
	"./document _upload/external_links_document_upload_handler.js": 17318,
	"./external_links_base_handler.js": 68616,
	"./fyp/external_links_forgot_handler.js": 19979,
	"./fyp/external_links_forgot_password_handler.js": 284,
	"./fyp/external_links_forgot_username_handler.js": 67547,
	"./membership/external_links_membership_handler.js": 29047,
	"./my_account/external_links_my_account_handler.js": 95263,
	"./pending_login/pending_login_handler.js": 11934,
	"./pending_play/pending_play_handler.js": 72215,
	"./rich/external_links_rich_handler.js": 63315,
	"./sport/external_links_sport_handler.js": 64575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3494;